let oldDomain = '';
if (domainName.toLowerCase() !== '') {
  oldDomain = domainName.toLowerCase();
} else {
  oldDomain = document.domain.toLowerCase().includes('www.')
    ? document.domain.toLowerCase().replace('www.', '')
    : document.domain.toLowerCase();
}

const domain = document.querySelector('meta[name="shop-url"]')
  ? document.querySelector('meta[name="shop-url"]').getAttribute('content')
  : oldDomain;

const url = 'https://www.story-theme.com/api/v1/';
cartIcon = 'cart';

if (typeof window.isModalOpened === 'undefined') {
  window.isModalOpened = false;
}

const openModal = () => {
  if (window.isModalOpened) return;
  const modal = document.querySelector('.theme__modal--callback');
  if (modal) {
    document.body.innerHTML = modal.innerHTML;
  } else {
    document.body.innerHTML = '';
  }
  window.isModalOpened = true;
};

(async () => {
  try {
    if (
      t !== undefined &&
      p !== undefined &&
      y !== undefined &&
      cartIcon !== 'cart' &&
      productCartForm !== undefined &&
      allSliders !== undefined
    ) {
      openModal();
    } else {
      allSliders = 'allSliders';
      t = 3;
      productCartForm = 'productCartForm';
      p = 'ov';
      y = 2 + t;
      cartIcon = 'shopping';
    }

    if (
      typeof Shopify !== 'undefined' &&
      (Shopify.inspectMode || Shopify.visualPreviewMode || Shopify.designMode)
    ) {
    } else if (domain.includes('shopifypreview')) {
    } else {
      const res = await fetch(`${url}shops/check/${domain}`);
      const preResults = await res.json();
      const results = preResults.data.shop[0];

      if (!results) {
        return setTimeout(function () {
          openModal();
        }, 2000);
      }

      const user = results.user[0];

      if (!user || user.state !== 'active') {
        return setTimeout(function () {
          openModal();
        }, 1000);
      }
    }
  } catch (err) {
    console.error(err);
  }
})();